module.exports = __webpack_public_path__ + "static/img/2099_phase_function_Paper_Points.6daebb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2099_phase_function_Paper_Points.png
// module id = 2tmL
// module chunks = 0